import type { AltYIdea } from '../types/global';

type IdeaListProps = {
  ideas: AltYIdea[];
  // Delete an idea by id. The parent reconciles the list after the broker
  // confirms (optimistic remove there).
  onDelete: (id: string) => void;
  // Close affordance. On desktop this flips back to the OneSheet iframe; on the
  // mobile overlay it drops back to the conversation. Omitted → no close button.
  onClose?: () => void;
};

// The Idea Agent's saved idea list — the right-pane (desktop) / full-screen
// overlay (mobile) view the "ideas" header toggle flips to. Read-only apart
// from per-row delete; new ideas are captured by the composer (see App.tsx),
// not added here.
export function IdeaList({ ideas, onDelete, onClose }: IdeaListProps) {
  return (
    <div className="alty-idea-list">
      <header className="alty-idea-list-head">
        <span className="alty-idea-list-title">
          <i className="fas fa-lightbulb" aria-hidden="true" />
          <span>Ideas</span>
          {ideas.length ? <span className="alty-idea-count">{ideas.length}</span> : null}
        </span>
        {onClose ? (
          <button
            type="button"
            className="alty-icon-button"
            title="Back"
            aria-label="Back"
            onClick={onClose}
          >
            <i className="fas fa-times" aria-hidden="true" />
          </button>
        ) : null}
      </header>
      {ideas.length === 0 ? (
        <div className="alty-idea-empty">
          <i className="fas fa-lightbulb" aria-hidden="true" />
          <p>No ideas yet.</p>
          <p className="alty-idea-empty-hint">Type a feature idea in the chat and it lands here.</p>
        </div>
      ) : (
        <ul className="alty-idea-items">
          {ideas.map((idea) => (
            <li key={idea.id} className="alty-idea-item">
              <span className="alty-idea-text">{idea.text}</span>
              <button
                type="button"
                className="alty-idea-delete"
                title="Delete idea"
                aria-label="Delete idea"
                onClick={() => onDelete(idea.id)}
              >
                <i className="fas fa-times" aria-hidden="true" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
